export default "/images/vendor/flag-icon-css/flags/4x3/bs.svg?5497678a4578b848e08d70e77484bbad";